import "./scorecardAbout.css";
import Header from "../Navigation/header";
import Footer from "../Navigation/footer";
import ScorecardHomeSubHeader from "./ScorecardHome/scorecardHomeSubHeader";
import "../../index.css";

const authors = [
  {
    name: "Peter Williams, Ph.D",
    role: "Chair of US chapter of ARISE",
    linkedin: "https://www.linkedin.com/in/peter-williams-de-phd/",
    description:
      "Internationally acknowledged expert in enabling sustainability & disaster resilience/ risk reduction | Application of technology in these areas| Advisor to many start-ups and 2 VC firms.",
    photo: "/images/scorecard/PeterWilliams.png",
  },
  {
    name: "Claudia Brenner",
    role: `Co-CEO, Catastrophic Wildfire Prevention Consortium at CrowdDoing <br /> CEO, Atomic Strategic Design`,
    linkedin: "https://www.linkedin.com/in/claudia-brenner/",
    description:
      "Business Strategist, Product Manager, Information Architect and Designer, Atomic Strategic Design | Systems Integration | Works at the convergence of business, design, technology and applied life sciences.",
    photo: "/images/scorecard/ClaudiaBrenner.jpg",
  },
  {
    name: "Robert Fishkin",
    role: "CEO & President, CrowdDoing",
    linkedin: "https://www.linkedin.com/in/bobbyfishkin/",
    description:
      "Social innovation, social enterprise and systemic change through service learning & skilled volunteering | Champions inchoate and emerging social innovation.",
    photo: "/images/scorecard/RobertFishkin.jpg",
  },

  {
    name: "Tammy Shwartz",
    role: "Managing Director, Guidewire",
    linkedin: "https://www.linkedin.com/in/tammynicholsschwartz/",
    description:
      "Previously Founder and CEO Black Swan Analytics LLC | Former Vice President, Underwriting and Operations California Fair Plan Assn.",
    photo: "/images/scorecard/TammyShwartz.jpg",
  },
  {
    name: "Alec Rodriguez",
    role: "Resilient Water Resources Engineer, Jacobs",
    linkedin: "https://www.linkedin.com/in/alec-rodriguez-p-e-cfm-16a03aa8/",
    description:
      "Co-Founder, Former Chair, Resilience Youth Network | Experienced in vulnerability and risk assessment, natural hazards mitigation, adaptation planning, and modeling.",
    photo: "/images/scorecard/AlecRodriguez.jpeg",
  },
];
const ScorecardAbout = () => {
  return (
    <>
      <ScorecardHomeSubHeader />
      <div className="scorecard-about">
        <div className="headers">
          <h2>About Us</h2>
          <h5>
            Thank you to our partners and collaborators for all your time,
            wisdom and support
          </h5>
          <h2>Our Scorecard Partnership</h2>
        </div>

        <div className="organizations">
          <div className="org cwpc">
            <h4>
              {" "}
              <img src="/images/header-footer/newlogo3.svg" alt="CWPC Logo" />
              Catastrophic Wildfire Prevention Consortium (CWPC) at CrowdDoing
            </h4>
            <p>
              CWPC is a cross-sector, international consortium of wildfire
              experts, institutions and volunteers focused on preventing
              catastrophic wildfires through a portfolio of customized,
              synergistic innovations for communities. CWPC is establishing the
              collective opportunity for net risk reduction by communities,
              achieved through multi-stakeholder collaboration using costs and
              liabilities of inaction model to finance action to prevent
              wildfire risks, and with a synergistic portfolio of new and
              traditional strategies for prevention, mitigation and adaptation.
              Learn more about{" "}
              <a href="/">
                {" "}
                Catastrophic Wildfire Prevention Consortium (CWPC) at CrowdDoing
              </a>
            </p>
          </div>
          <div className="org arise">
            <h4>
              {" "}
              <img
                src="/images/header-footer/arise_wo_bg.png"
                alt="Arise Logo"
              />
              ARISE-US
            </h4>
            <p>
              ARISE-US is the US network of ARISE, established by the United
              Nations (UN) to build public-private collaboration in disaster
              resilience. We are a 100% volunteer organization operating in 35
              countries worldwide, with 450 corporate members and many more NGO
              and governmental partners. We published the original UN City
              Disaster Resilience Scorecard, now used by roughly 350 cities
              worldwide (including many in the US), on which this
              wildfire-specific scorecard is modeled and several other
              scorecards, and a free critical asset management tool. Learn more
              about{" "}
              <a
                href="https://www.arise-us.org/"
                target="_blank"
                rel="noreferrer"
              >
                ARISE-US
              </a>
            </p>
          </div>
          <div className="org crowd-doing">
            <h4>
              {" "}
              <img
                src="/images/header-footer/cd-logo.png"
                alt="CrowdDoing Logo"
              />
              CrowdDoing
            </h4>
            <p>
              CrowdDoing (CD) is a joint initiative of the Match4Action
              Foundation and ReframeIt, focused on addressing the social,
              economic, and environmental challenges our world faces by
              collaborating with professionals and volunteers from many
              different industries. CD aims to support social innovations with
              transformative impact potential through global multi-disciplinary
              volunteering, micro-leadership and service learning. Learn more
              about{" "}
              <a
                href="https://crowddoing.world/"
                target="_blank"
                rel="noreferrer"
              >
                CrowdDoing
              </a>
            </p>
          </div>
        </div>
        <div className="authors">
          <h2>Meet the Authors</h2>
          <div className="authors-cards-wrapper">
            {authors &&
              authors.map((author) => (
                <div className="author-card">
                  <div className="card-top">
                    <div className="photo">
                      <img src={author.photo} alt={author.name} />
                    </div>
                    <div className="personal-data">
                      <h4 className="name">{author.name}</h4>
                      <div
                        dangerouslySetInnerHTML={{ __html: author.role }}
                      ></div>
                      <div className="linkedin">
                        <a
                          href={author.linkedin}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {" "}
                          <i className="fab fa-linkedin"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="card-bottom">{author.description}</div>
                </div>
              ))}
          </div>
        </div>
        <div className="collaborators">
          <h2>Scorecard Collaborators</h2>
          <div className="collaborators-wrapper">
            <div className="collaborators-col">
              <h5>Authors</h5>
              <ul>
                <li>Peter Williams, ARISE-US</li>
                <li>Claudia Brenner, Crowddoing</li>
                <li>Bobby Fishkin, Crowddoing</li>
                <li>Bruce Preville, Crowddoing</li>
                <li>Rebecca Innes, Rebecca Innes Consulting</li>
                <li>Diana Daubenspeck, Black Swan</li>
                <li>Tammy Schwartz, Guidewire and Black Swan</li>
                <li>Alec Rodriguez, Jacobs Engineering</li>
              </ul>
            </div>
            <div className="collaborators-col">
              <h5>Reviewers</h5>
              <ul>
                <li>
                  Brent Woodworth, Los Angeles Emergency Preparedness Foundation
                </li>
                <li>Shefali Lakhina, Wonderlabs</li>
                <li>Charlie Sidoti, Innsure</li>
                <li>Chris Lowell, Innsure</li>
                <li>Alec Rodriguez, Atkins</li>
                <li>Phetmano Phannavong, Atkins</li>
                <li>Kevin Bush, Cadmus Group</li>
                <li>Randy Lyle, Wildfire Mitigation Strategies</li>
                <li>Geoff Bruder, Incaendium Initiative</li>
                <li>Craig Froome, Energetic Effects</li>
                <li>Goutam Sinha, Crowddoing</li>
              </ul>
            </div>
          </div>
          <div className="teams">
            <h2>Scorecard Web, Marketing and Data Team</h2>
            <div className="collaborators-wrapper">
              <div className="collaborators-col">
                <h5>Core Web Team</h5>
                <ul>
                  <li>
                    Sadiya Bhawania, Full Stack Developer (Technical Lead)
                  </li>
                  <li>Valka Gupta, Business & Content</li>
                  <li>Karen Tsai, UX & Content</li>
                  <li>James Johnson, Software Engineer</li>
                  <li>Fuzel Hafiz, Operations & QA</li>
                  <li>Prabhakaran Jayasankar, SEO & Analytics</li>
                </ul>
              </div>

              <div className="collaborators-col">
                <h5>Web Support Team</h5>
                <ul>
                  <li>Hiral Rajesh Nagda</li>
                  <li>Roberta Lacerda</li>
                  <li>Hemaxi Barot</li>
                  <li>Arman Khehra</li>
                  <li>Devarishi Shinde</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ScorecardAbout;
